import React from 'react';
import {STSearchBar} from './styles';
import {IconButton, InputBase} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import {Values} from "Tools/Values";

interface IProps {
    value: string
    onChange: (text: string) => void
}

const LocationSearch = ({onChange, value}: IProps) => {
    return (
        <STSearchBar>
            <IconButton aria-label="search">
                <SearchIcon/>
            </IconButton>

            <InputBase
                value={value}
                onChange={(ev) => onChange(ev.target.value)}
                style={{width: "100%", paddingTop: "2px"}}
                placeholder={Values.getLocalizationValue("search")}
                inputProps={{'aria-label': 'search'}}
            />
        </STSearchBar>
    );
};

export default LocationSearch;